const search = () => {

    function formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    var firstDate = new Date();

    /*
    if(firstDate.getDay() == 4){
        firstDate.setDate(firstDate.getDate() + 4);
    } else
    */

    if(firstDate.getDay() == 5){
        firstDate.setDate(firstDate.getDate() + 3);
    } else if(firstDate.getDay() == 6){
        firstDate.setDate(firstDate.getDate() + 3);
    } else if(firstDate.getDay() == 0){
        firstDate.setDate(firstDate.getDate() + 2);
    } else {
        firstDate.setDate(firstDate.getDate() + 1);
    }

    $('#search-start-date').datepicker({
        startDate: firstDate,
        language: 'pl-PL',
        format: 'yyyy-mm-dd',
        autoShow: false,
        inline: false,
        container: '.form-group.date-start',
        autoHide: true,
        filter: function(date, view) {
            if ((date.getDay() === 0 || date.getDay() === 6) && view === 'day') {
                return false; // Disable weekends
            }
        },
    });

    var dateStartFromForm = $('#dateStart').val();

    if(dateStartFromForm && dateStartFromForm >= formatDate(firstDate)){
        $('#search-start-date').datepicker("setDate", dateStartFromForm);
    } else {
        $('#search-start-date').datepicker("setDate", firstDate);
    }

    var placeSearch, autocomplete;

    // get location after click/focus
    $('#autocomplete').on('focus', function(){
        $('.error-location').fadeOut();

        if($(this).val() == "") {
            geolocate();
        }
    });

    // do not submit form on autocomplete ENTER key
    $('#autocomplete').keydown(function (e) {
        if (e.which == 13) {
            return false;
        }
    });

    if($("#autocomplete").length != 0) {
        // Create the autocomplete object, restricting the search predictions to
        // geographical location types.
        autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('autocomplete'), {types: ['geocode']}
            // document.getElementById('autocomplete'), {types: ['address']}
        );

        autocomplete.setComponentRestrictions({'country': ['pl']});

        // Avoid paying for data that you don't need by restricting the set of
        // place fields that are returned to just the address components.
        autocomplete.setFields(['formatted_address', 'address_component', 'geometry']);

        // When the user selects an address from the drop-down, populate the
        // address fields in the form.
        autocomplete.addListener('place_changed', fillInAddress);
    }

    function fillInAddress() {
        // Get the place details from the autocomplete object.
        var place = autocomplete.getPlace();
        // console.log(place);

        if (place.geometry){

            $('#search-street').val("");
            $('#search-city').val("");
            $('#search-postalcode').val("");
            $('#search-country').val("");
            $('#search-county').val("");

            var premise = "";
            var streetAddress = "";
            var streetNumber = "";
            var zipCode = "";
            var city = "";
            var country = "";
            var county = "";

            var lat = place.geometry.location.lat();
            var lng = place.geometry.location.lng();

            var pos = new google.maps.LatLng(lat, lng);

            if (window.marker){
                window.marker.setPosition(pos);
            }

            if (typeof window.minimap === 'object'){
                window.minimap.setCenter(pos);
            }

            $('#search-latitude').val(lat);
            $('#search-longitude').val(lng);
            $('#gps-latitude').val(lat);
            $('#gps-longitude').val(lng);

            place.address_components.forEach(function(item){
                if (item.types.indexOf("premise") != -1) {
                    premise = item.long_name;
                }

                if (item.types.indexOf("street_number") != -1) {
                    streetNumber = item.long_name;
                }

                if (item.types.indexOf("route") != -1) {
                    if (item.long_name != "Unnamed Road"){
                        streetAddress = item.long_name;
                    }
                }

                if (item.types.indexOf("locality") != -1) {
                    city = item.long_name;
                }

                if (item.types.indexOf("administrative_area_level_2") != -1) {
                    county = item.long_name;
                }

                if (item.types.indexOf("postal_code") != -1) {
                    zipCode = item.long_name;
                }

                if (item.types.indexOf("country") != -1) {
                    country = item.long_name;
                }
            });

            if (streetAddress == "" && premise != ""){
                if (city != ""){
                    streetAddress = city + ' ' + premise;
                } else {
                    streetAddress = premise;
                }
            }

            /*
            console.log(streetAddress+' '+streetNumber);
            console.log(city);
            console.log(zipCode);
            console.log(county);
            */

            $('#search-street').val((streetAddress+' '+streetNumber).trim());
            $('#search-city').val(city.trim());
            $('#search-postalcode').val(zipCode.trim());
            $('#search-country').val(country.trim());
            $('#search-county').val(county.trim());

            var replaceCity = false;
            var replacePostalcode = false;

            if (city.trim() == "") {
                // console.log('getDataFromLocation - city');
                replaceCity = true;
            }

            if (zipCode.trim().length < 6 ) {
                // console.log('getDataFromLocation - postalcode');
                replacePostalcode = true;
            }

            if (replaceCity || replacePostalcode){
                getDataFromLocation(lat, lng, replaceCity, replacePostalcode);
            }
        }
    }

    function getDataFromLocation(lat, lng, replaceCity, replacePostalcode) {
        var latlng = new google.maps.LatLng(lat, lng);
        var geocoder = new google.maps.Geocoder();

        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                console.log(status);
            }

            if (status == google.maps.GeocoderStatus.OK) {
                var premise = "";
                var city = "";
                var zipCode = "";

                // console.log(results);

                results.forEach(function(res){
                    res.address_components.forEach(function(item){
                        if (item.types.indexOf("premise") != -1) {
                            premise = item.long_name;
                        }

                        if (item.types.indexOf("postal_code") != -1 && item.long_name.length == 6) {
                            zipCode = item.long_name;
                        }

                        if (item.types.indexOf("locality") != -1) {
                            city = item.long_name;
                        }
                    });
                });

                if(replaceCity && city.trim() != ""){
                    $('#search-city').val(city.trim());
                }

                if(replacePostalcode && zipCode.trim().length >= 6){
                    $('#search-postalcode').val(zipCode.trim());
                }
            }
        });
    }

    function getAddressFromLocation(lat, lng) {
        var latlng = new google.maps.LatLng(lat, lng);
        var geocoder = new google.maps.Geocoder();

        $('#search-latitude').val(lat);
        $('#search-longitude').val(lng);
        $('#gps-latitude').val(lat);
        $('#gps-longitude').val(lng);

        geocoder.geocode({ 'latLng': latlng }, function (results, status) {
            if (status !== google.maps.GeocoderStatus.OK) {
                console.log(status);
            }

            if (status == google.maps.GeocoderStatus.OK) {
                var premise = "";
                var streetAddress = "";
                var streetNumber = "";
                var zipCode = "";
                var city = "";
                var country = "";
                var county = "";

                // console.log(results);

                results[0].address_components.forEach(function(item){
                    if (item.types.indexOf("premise") != -1) {
                        premise = item.long_name;
                    }

                    if (item.types.indexOf("street_number") != -1) {
                        streetNumber = item.long_name;
                    }

                    if (item.types.indexOf("route") != -1) {
                        if (item.long_name != "Unnamed Road"){
                            streetAddress = item.long_name;
                        }
                    }

                    if (item.types.indexOf("locality") != -1) {
                        city = item.long_name;
                    }

                    if (item.types.indexOf("administrative_area_level_2") != -1) {
                        county = item.long_name;
                    }

                    if (item.types.indexOf("postal_code") != -1) {
                        zipCode = item.long_name;
                    }

                    if (item.types.indexOf("country") != -1) {
                        country = item.long_name;
                    }
                });

                if (streetAddress == "" && premise != "") {
                    if (city != "") {
                        streetAddress = city + ' ' + premise;
                    } else {
                        streetAddress = premise;
                    }
                }

                var fullAddress = (results[0].formatted_address);

                $('#autocomplete').val(fullAddress);
                $('#search-street').val((streetAddress + " " + streetNumber).trim());
                $('#search-postalcode').val(zipCode.trim());
                $('#search-city').val(city.trim());
                $('#search-country').val(country.trim());
                $('#search-county').val(county.trim());
            }
        });
    }

    var gpsErrorShowed = false;

    function showGpsError(error) {
        switch(error.code) {
            case error.PERMISSION_DENIED:
                console.log("User denied the request for Geolocation.");
                if (!gpsErrorShowed){
                    alert('Aby umożliwić pobranie lokalizaji, nadaj uprawnienia GPS w opcjach twojej przeglądarki.');
                    gpsErrorShowed = true;
                }
                break;
            case error.POSITION_UNAVAILABLE:
                console.log("Location information is unavailable.");
                alert('Dane lokalizacji nie są dostępne.');
                break;
            case error.TIMEOUT:
                console.log("The request to get user location timed out.");
                alert('Dane lokalizacji nie są dostępne (timeout).');
                break;
            case error.UNKNOWN_ERROR:
                console.log("An unknown error occurred.");
                alert('Dane lokalizacji nie są dostępne (error).');
                break;
        }
    }

    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    function geolocate() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                $('#gps-latitude').val(pos.lat);
                $('#gps-longitude').val(pos.lng);

                getAddressFromLocation(pos.lat, pos.lng);

                /*
                var geolocation = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
                };
                var circle = new google.maps.Circle(
                    {center: geolocation, radius: position.coords.accuracy});
                autocomplete.setBounds(circle.getBounds());
                */
            }, showGpsError);
        }
    }

    $('#search-form').on('submit', function(){
       return SearchFormValidate();
    });

    function SearchFormValidate(){
        // console.log('Validate');
        var error = false;
        var errorLocation = false;
        var searchStreet = $('#search-street').val().trim();
        var searchCity = $('#search-city').val().trim();
        var searchPostalcode = $('#search-postalcode').val().trim();
        var searchService = $('#search-service').val();

        var autocomplete = $('#autocomplete');
        var offset = $('#autocomplete').offset().top-200;

        $('#search-form .form-group').removeClass('error');
        $('.error-location').fadeOut();

        /*
        if(searchStreet == ""){
            autocomplete.closest('.form-group').addClass('error');
            autocomplete.addClass('shake');

            $('html, body').animate({
                scrollTop: offset
            }, 500);

            error = true;
            errorLocation = true;
        }
        */

        if(searchCity == ""){
            autocomplete.closest('.form-group').addClass('error');
            autocomplete.addClass('shake');

            $('html, body').animate({
                scrollTop: offset
            }, 500);

            error = true;
            errorLocation = true;
            // console.log("searchCity == ");
        }

        if(searchPostalcode == "" || searchPostalcode.length < 6 ){
            autocomplete.closest('.form-group').addClass('error');
            autocomplete.addClass('shake');

            $('html, body').animate({
                scrollTop: offset
            }, 500);


            error = true;
            errorLocation = true;
            // console.log("searchPostalcode == ");
        }

        if(searchService == 0){
            $('#search-service').closest('.form-group').addClass('error');
            $('#search-service').next('.nice-select').addClass('shake');

            $('html, body').animate({
                scrollTop: offset
            }, 500);

            error = true;
            // console.log("searchService == 0");
        }

        if (error){
            setTimeout(function(){
                $('#search-form input').removeClass('shake');
                $('#search-form .nice-select').removeClass('shake');
            }, 500);

            if (errorLocation){
                $('.error-location').fadeIn();
            }

            return false;
        }

        return true;
    }

    $('#autocomplete').on('input', function(){
        $('#search-street').val("");
        $('#search-city').val("");
        $('#search-postalcode').val("");
        $('#search-country').val("");
        $('#search-latitude').val("");
        $('#search-longitude').val("");

        $('.results-info').slideUp(function(){
            $('.results-rows').slideUp(function(){
                $('.search-again').slideDown();
            });
        });
    });

    $('#search-start-date, #search-service').on('change', function(){
        $('.results-info').slideUp(function(){
            $('.results-rows').slideUp(function(){
                $('.search-again').slideDown();
            });
        });
    });

    /*
     * Centrum Warszawa: 52.232855, 20.9211126
     */
    var pos = {
            lat: 52.232855,
            lng: 20.9211126
        }

    var gpsLat = $('#gps-latitude').val();
    var gpsLng = $('#gps-longitude').val();

    if (gpsLat != "" && gpsLng != ""){
        pos = {
            lat: gpsLat,
            lng: gpsLng
        }
    }

    // console.log(pos);
    var mapVisible = $("#minimap").length;

    if (pos && mapVisible){
        var mapCenter = new google.maps.LatLng(pos.lat, pos.lng),
            laptop_width = 1200,
            isDraggable = document.body.clientWidth >= laptop_width ? true : false,
            args = {
                zoom: 13,
                center: mapCenter,
                zoomControl: true,
                mapTypeControl: false,
                streetViewControl: false,
                draggable: isDraggable,
                scrollwheel: false,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };


        // Create a map object and specify the DOM element for display.
        window.minimap = new google.maps.Map(document.getElementById('minimap'), args);

        var styles = [];

        var userPin = new google.maps.LatLng(pos.lat, pos.lng);
        window.marker = new google.maps.Marker({
            position: userPin,
            map: minimap,
            icon: "/img/front/pin.png",
            draggable: false
        });

        window.markerPopup = new google.maps.InfoWindow({
            content     : "Aktualna lokalizacja",
        });

        google.maps.event.addListener(marker, 'click', function() {
            markerPopup.open( minimap, marker );
        });
    }

    // Result rows
    function countOrderPrice(element){
        var vat = 0.08;
        var productId = $('#'+element).attr('productId');
        var price = parseFloat($('#'+element).attr('price'));
        var priceService = parseFloat($('#'+element).attr('priceService'));
        var priceDelivery = parseFloat($('#'+element).attr('priceDelivery'));
        var priceInsurance = parseFloat($('#'+element).attr('priceInsurance'));
        var priceOther = parseFloat($('#'+element).attr('priceOther'));
        var priceExpress = parseFloat($('#'+element).attr('priceExpress'));
        var count = parseInt($('#'+element).find('input[name=count]').val());
        var optionInsurance = $('#'+element).find('input[name=optionInsurance]').prop('checked');
        var optionOther = $('#'+element).find('input[name=optionOther]').prop('checked');

        // var optionExpress = $('#'+element).find('input[name=optionExpress]').prop('checked');

        var optionExpress = false;

        if (priceExpress > 0){
            optionExpress = true;
        }

        /*
        console.log(price);
        console.log(priceService);
        console.log(priceDelivery);
        console.log(priceInsurance);
        console.log(priceOther);
        console.log(count);
        console.log(optionInsurance);
        console.log(optionOther);
        */

        var total = (price  * 4 * count) + (priceService * count) + priceDelivery + priceExpress;

        if (optionInsurance) {
            total = total + (priceInsurance * count);
        } else {
            priceInsurance = 0;
        }

        if (optionOther) {
            total = total + (priceOther * count);
        } else {
            priceOther = 0;
        }

        /*
        if (optionExpress) {
            total = total + priceExpress;
        } else {
            priceExpress = 0;
        }
        */

        var totalBrutto = total + (total * vat);

        total = total.toFixed(2);
        totalBrutto = totalBrutto.toFixed(2);

        $('#'+element).find('.price-value').html(totalBrutto.replace('.', ',') + ' pln');

        $('#productId').val(productId);
        $('#productCount').val(count);
        $('#price').val(price);
        $('#price-total').val(total);
        $('#price-service').val(priceService);
        $('#price-delivery').val(priceDelivery);
        $('#price-insurance').val(priceInsurance);
        $('#price-other').val(priceOther);
        $('#price-express').val(priceExpress);
        $('#option-insurance').val(optionInsurance);
        $('#option-other').val(optionOther);
        $('#option-express').val(optionExpress);
    }

    $('.results-rows').on('click', '.btn-count', function(){
        var input = $(this).closest('.counting-box').find('input');
        var value = input.val();
        var increment = $(this).hasClass('inc');

        if (increment) {
            value++;
        } else {
            if (value > 1){
                value--;
            }
        }

        input.val(value);

        var orderElement = $(this).closest('.result-item').attr('id');
        countOrderPrice(orderElement);
    });

    $('.results-rows').on('change', 'input[name=optionInsurance]', function(){
        var orderElement = $(this).closest('.result-item').attr('id');
        countOrderPrice(orderElement);
    });

    $('.results-rows').on('change', 'input[name=optionOther]', function(){
        var orderElement = $(this).closest('.result-item').attr('id');
        countOrderPrice(orderElement);
    });

    /*
    $('.results-rows').on('change', 'input[name=optionExpress]', function(){
        var orderElement = $(this).closest('.result-item').attr('id');
        countOrderPrice(orderElement);

        $(this).closest('.result-item').find('.delivery-dates').toggleClass('express');
    });
    */

    $('.results-rows').on('change', '.counting-box input', function(){
        var orderElement = $(this).closest('.result-item').attr('id');
        countOrderPrice(orderElement);
    });

    $('.results-rows').on('click', '.btn-order-submit', function(e){
        var orderElement = $(this).closest('.result-item').attr('id');
        $(this).html('Zamawiam ...');
        countOrderPrice(orderElement);
    });

    $('.results-rows i[data-toggle="tooltip"]').tooltip({ trigger: 'click hover'});
}

 module.exports = {
    search,
 };
